<script setup>
  import {computed, ref} from "vue";

  const props = defineProps({
    value: {
      type: [Object, Array, String, Number, Boolean, null],
      required: true,
    },
    level: {
      type: Number,
      default: 0,
    },
  });

  const parsed = computed(() => {
    if (typeof props.value !== "string") return props.value;
    try {
      return JSON.parse(props.value);
    } catch {
      return props.value;
    }
  });

  const isArray = computed(() => Array.isArray(parsed.value));
  const isObject = computed(() => parsed.value !== null && typeof parsed.value === "object");

  const entries = computed(() => {
    if (isArray.value) return parsed.value.map((v, i) => [i, v]);
    if (isObject.value) return Object.entries(parsed.value);
    return [];
  });

  const open = ref(props.level < 1);
</script>

<template>
  <div class="json-node" :style="{paddingLeft: `${level * 14}px`}">
    <template v-if="!isObject">
      <span class="value">{{ String(parsed) }}</span>
    </template>

    <template v-else>
      <button type="button" class="toggle" :aria-expanded="open" @click="open = !open">
        {{ open ? "▼" : "▶" }}
      </button>
      <span class="bracket">{{ isArray ? "[" : "{" }}</span>
      <span class="meta">{{ entries.length }}</span>

      <template v-if="open">
        <div v-for="[key, val] in entries" :key="key">
          <span v-if="!isArray" class="key">"{{ key }}":</span>
          <DeveloperJsonViewer :value="val" :level="level + 1" />
        </div>

        <div :style="{paddingLeft: `${level * 14}px`}">{{ isArray ? "]" : "}" }}</div>
      </template>
    </template>
  </div>
</template>

<style scoped>
  .json-node {
    font-family: monospace;
    font-size: 13px;
    line-height: 1.5;
  }

  .toggle {
    cursor: pointer;
    margin-right: 4px;
  }

  .key {
    color: #b04;
    margin-right: 6px;
  }

  .value {
    color: #036;
  }

  .meta {
    color: #999;
    margin-left: 6px;
  }

  .bracket {
    margin-right: 4px;
  }
</style>
